enum ActionTypes {
  SET_PERMISSIONS = "SET_PERMISSIONS",
  CLEAR_PERMISSIONS = "CLEAR_PERMISSIONS",
}

export default ActionTypes;
